import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import { api_path } from "../../shared.js";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import swal from "sweetalert";
import Select from "react-select";
import axios from "axios";
export function RegisterForm() {
  const { instance, accounts } = useMsal();
  //const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const [getUserID, setUserID] = useState("");
  const getEmpCode = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const [searchParams] = useSearchParams();
  const crmid = searchParams.get("crmid");
  const [accessToken, setAccessToken] = useState(null);
  const [GET_USER_EMAIL, SET_USER_EMAIL] = useState("");
  const [GET_USER_FIRSTNAME, SET_USER_FIRSTNAME] = useState("");
  const [GET_USER_LASTNAME, SET_USER_LASTNAME] = useState("");
  const [GET_USER_NICKNAME, SET_USER_NICKNAME] = useState("");
  const [GET_USER_ROLE_ID, SET_USER_ROLE_ID] = useState(0);
  const [GET_USER_MOBILE, SET_USER_MOBILE] = useState("");
  const [GET_USER_TEL, SET_USER_TEL] = useState("");
  const [GET_USER_TEL_EXT, SET_USER_TEL_EXT] = useState("");
  const [GET_EMP_CODE, SET_EMP_CODE] = useState("");
  const [GET_USER_POSITION, SET_USER_POSITION] = useState("");
  const [getTel, setTel] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [getRoleName, setRoleName] = useState("");
  const [buttonName, setButtonName] = useState("");
  const navigate = useNavigate();
  const [getRole, setRole] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [selectRole, setSelectRole] = useState([]);
  const [getOrigin, setOrigin] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [selectOrigin, setSelectOrigin] = useState([]);
  const goBack = () => {
    navigate(-1);
  };
  function RequestAccessToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.accessToken);
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          setAccessToken(response.accessToken);
        });
      });
  }
  useEffect(() => {
    SET_USER_EMAIL(accounts[0]?.username);
    fetchCountry();
    fetchRoleData();
  }, []);
  useEffect(() => {
    fetch(api_path + "/MS_USER_PROFILE.php?USER_EMAIL=" + GET_USER_EMAIL)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        if (array.length > 0) {
          for (const i of array) {
            setUserID(i.CRM_UID);
            SET_USER_EMAIL(i.USER_EMAIL);
            SET_USER_FIRSTNAME(i.USER_FIRSTNAME);
            SET_USER_LASTNAME(i.USER_LASTNAME);
            SET_USER_NICKNAME(i.USER_NICKNAME);
            SET_USER_TEL(i.USER_TEL);
            SET_USER_TEL_EXT(i.USER_TEL_EXT);
            SET_USER_MOBILE(i.USER_MOBILE);
            SET_USER_POSITION(i.USER_POSITION);
            SET_EMP_CODE(i.EMP_CODE);
            setSelectOrigin(i.ORIGIN_COUNTRY);
            setOrigin({
              COUNTRY_NAME: i.COUNTRY_NAME,
              COUNTRY_CODE: i.ORIGIN_COUNTRY,
            });

            setSelectRole(i.USER_ROLE_ID);
            setRole({
              ROLE_ID: i.USER_ROLE_ID,
              ROLE_NAME: i.ROLE_NAME,
            });
            if (i.USER_ROLE_ID > 0) {
              setRoleName(i.ROLE_NAME);
            }
            setSubjectName("Edit your profile");
            setButtonName("Update");
          }
        } else {
          setSubjectName("New Register");
          setButtonName("Save");
        }
      });
  }, [GET_USER_EMAIL]);
  const handleSubmit = (event) => {
    event.preventDefault();
    let methodKey = "";
    if (getUserID > 0) {
      methodKey = "PUT";
      var data = {
        USER_EMAIL: GET_USER_EMAIL,
        USER_FIRSTNAME: GET_USER_FIRSTNAME,
        USER_LASTNAME: GET_USER_LASTNAME,
        USER_NICKNAME: GET_USER_NICKNAME,
        USER_MOBILE: GET_USER_MOBILE,
        USER_TEL: GET_USER_TEL,
        USER_TEL_EXT: GET_USER_TEL_EXT,
        USER_POSITION: GET_USER_POSITION,
        USER_ROLE_ID: selectRole,
        EMP_CODE: GET_EMP_CODE,
        COUNTRY: selectOrigin,
        ACCESS_TOKEN: accessToken,
        CRM_UID: getUserID,
      };
    } else {
      methodKey = "POST";
      var data = {
        USER_EMAIL: GET_USER_EMAIL,
        USER_FIRSTNAME: GET_USER_FIRSTNAME,
        USER_LASTNAME: GET_USER_LASTNAME,
        USER_NICKNAME: GET_USER_NICKNAME,
        USER_MOBILE: GET_USER_MOBILE,
        USER_TEL: GET_USER_TEL,
        USER_TEL_EXT: GET_USER_TEL_EXT,
        USER_POSITION: GET_USER_POSITION,
        USER_ROLE_ID: 0,
        EMP_CODE: GET_EMP_CODE,
        COUNTRY: selectOrigin,
        ACCESS_TOKEN: accessToken,
      };
    }
    fetch(api_path + "/MS_USER_PROFILE.php", {
      method: methodKey,
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 10000,
          }).then(function () {
            if (getUserID > 0) {
            } else {
              window.location = "/s-crm/RequestUserRole";
            }
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 10000,
          });
        }
      });
  };
  const fetchCountry = () => {
    axios
      .get(api_path + `/GET_COUNTRY.php?ALL=2`)
      .then((response) => {
        setOriginList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOriginChange = (obj) => {
    setSelectOrigin(obj.COUNTRY_CODE);
    setOrigin({
      COUNTRY_CODE: obj.COUNTRY_CODE,
      COUNTRY_NAME: obj.COUNTRY_NAME,
    });
  };

  const fetchRoleData = () => {
    axios
      .get(api_path + `/MS_USER_ROLE.php`)
      .then((response) => {
        setRoleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRoleChange = (obj) => {
    setSelectRole(obj.ROLE_ID);
    setRole({ ROLE_ID: obj.ROLE_ID, ROLE_NAME: obj.ROLE_NAME });
  };
  return (
    <Container maxWidth="md" className="BorderBox">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            {" "}
            <label>role </label>
            <br />
            {getRoleName}
            {/* <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getRole}
              options={roleList}
              onChange={handleRoleChange}
              getOptionLabel={(x) => x.ROLE_NAME}
              getOptionValue={(x) => x.ROLE_ID}
              isdisabled={false}
    
              required
            /> */}
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>Email</label>
            <TextField
              size="small"
              name="GET_USER_EMAIL"
              variant="outlined"
              fullWidth
              id="GET_USER_EMAIL"
              value={GET_USER_EMAIL}
              inputProps={{ readOnly: true }}
              onChange={(e) => SET_USER_EMAIL(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>Country</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getOrigin}
              options={originList}
              onChange={handleOriginChange}
              getOptionLabel={(x) => x.COUNTRY_NAME}
              getOptionValue={(x) => x.COUNTRY_CODE}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>
              Employee Code<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
              // type="number" //ad this line
              // onInput={(e) => {
              //   e.target.value = Math.max(0, parseInt(e.target.value))
              //     .toString()
              //     .slice(0, 4);
              // }}
              //min={0}
              size="small"
              name="GET_EMP_CODE"
              variant="outlined"
              fullWidth
              id="GET_EMP_CODE"
              value={GET_EMP_CODE}
              required
              autoComplete="off"
              onChange={(e) => SET_EMP_CODE(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>
              Name<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 100);
              }}
              size="small"
              name="GET_USER_FIRSTNAME"
              variant="outlined"
              fullWidth
              id="GET_USER_FIRSTNAME"
              value={GET_USER_FIRSTNAME}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_FIRSTNAME(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>
              LastName<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 100);
              }}
              size="small"
              name="GET_USER_LASTNAME"
              variant="outlined"
              fullWidth
              id="GET_USER_LASTNAME"
              value={GET_USER_LASTNAME}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_LASTNAME(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>
              Nickname<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              size="small"
              name="GET_USER_NICKNAME"
              variant="outlined"
              fullWidth
              id="getNickGET_USER_NICKNAMEName"
              value={GET_USER_NICKNAME}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_NICKNAME(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>
              Position<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              min={0}
              size="small"
              name="GET_USER_POSITION"
              variant="outlined"
              fullWidth
              id="GET_USER_POSITION"
              value={GET_USER_POSITION}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_POSITION(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>
              Telephone<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              min={0}
              size="small"
              name="GET_USER_TEL"
              variant="outlined"
              fullWidth
              id="GET_USER_TEL"
              value={GET_USER_TEL}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_TEL(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>
              EXT<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 5);
              }}
              min={0}
              size="small"
              name="GET_USER_TEL_EXT"
              variant="outlined"
              fullWidth
              id="GET_USER_TEL_EXT"
              value={GET_USER_TEL_EXT}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_TEL_EXT(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>
              Mobile<span className="red">*</span>
            </label>
            <TextField
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              min={0}
              size="small"
              name="GET_USER_MOBILE"
              variant="outlined"
              fullWidth
              id="GET_USER_MOBILE"
              value={GET_USER_MOBILE}
              required
              autoComplete="off"
              onChange={(e) => SET_USER_MOBILE(e.target.value)}
            />
          </Grid>
          <br />
          <Grid container className="Box" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                {buttonName}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={goBack}
              >
                &larr; Go Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

export default RegisterForm;
